const loaderStyle = {
  background:
    "no-repeat linear-gradient(#f97316 0 0), no-repeat linear-gradient(#f97316 0 0), #e5e5e5",
  backgroundSize: "60% 100%",
  animation: "l16 3s infinite",
  borderRadius: "24px",
};

const keyframes = `
  @keyframes l16 {
    0%   {background-position:-150% 0,-150% 0}
    66%  {background-position: 250% 0,-150% 0}
    100% {background-position: 250% 0, 250% 0}
  }
`;

export default function AuthLoader() {
  return (
    <div className="h-screen flex flex-col items-center justify-center">
      <style>{keyframes}</style>

      <img
        className="z-10 w-20 md:w-32"
        src="/logo-w-logotype.svg"
        alt="Zerply"
      />

      <div className="mt-6 h-1 w-80" style={loaderStyle}></div>
    </div>
  );
}
